<section *ngIf="properties && properties.length > 0" class="border border-smoke rounded p-4 max-h-96 overflow-y-auto">
  <mat-checkbox (change)="allPropertiesChange($event)"><strong class="pl-1">All properties</strong></mat-checkbox>

  <sbnb-search-bar class="block mt-4" (searchChanged)="searchCriteria$.next($event)"></sbnb-search-bar>

  <mat-checkbox
    *ngFor="let property of filteredProperties"
    [checked]="isPropertySelected(property)"
    [disabled]="isPropertyDisabled(property.id)"
    [matTooltip]="isPropertyDisabled(property.id) ? getDisabledReason(property.id) : ''"
    class="w-full"
    (change)="propertyCheckboxChange(property, $event)">
    <div class="flex items-center">
      <img [src]="property.picture" alt="Property image" class="w-7 h-5 rounded mr-2" />
      <span class="flex-1">{{ property.name }}</span>
    </div>
  </mat-checkbox>
</section>
